<style lang="less">
    @import '../../../../styles/common-table-list.less';
</style>
<template>
    <div class="center-table-list">
        <div class="table-list" style="margin-top:25px;height: auto;min-height: 726px;">
            <div class="table-list-title">
                <span style="margin-left:25px">我的登记</span>
                <div class="choose-group">
                    <span class="choose-group-span">业务类型</span>
                    <i-select v-model="serviceValue" placeholder="全部" style="width:126px" @on-change="selectType">
                        <i-option v-for="(item,index) in serviceList" :key="index" :value="item.subBizType">{{
                            item.name}}
                        </i-option>
                    </i-select>
                    <span class="choose-group-span">时间</span>
                    <Date-picker
                            v-model="dateValue"
                            format="yyyy-MM-dd"
                            type="daterange"
                            placement="bottom-end"
                            @on-change="timeChange"
                            placeholder="选择日期"
                            style="width: 200px"
                    ></Date-picker>

                    <i-input
                            v-model="workFullname"
                            ref="workFullnameInput"
                            :search="true"
                            @on-search="searchReset"
                            placeholder="请输入作品名称"
                            style="width: 205px"
                            class="select-input-style"
                    ></i-input>
                    <button @click="searchReset" class="btn-84" style="margin:0 0px 0 20px">查询</button>
                    <button class="btn-84" style="margin:0px 30px 0px 20px" @click="newOpen">新增登记</button>
                    <!--            <button class="btn-84" style="margin:0px 30px 0px 20px">新增监测</button>-->
                </div>
            </div>
<!--             <div class="caozuo-box">
                <button class="xuqi_btn" @click="insuranceCert">上保险</button>
                <img src="../../insurance/images/wenhao.png" style="width:16px;height:16px;cursor: pointer;" @click="goInsurance" alt='版权登记'/>
            </div>-->
            <Row class="table-style-size">
                <i-col span="1">选择</i-col>
                <i-col span="2">业务类型</i-col>
                <i-col span="2">证书编号</i-col>
                <i-col span="2">作品名称</i-col>
                <i-col span="3">提交时间</i-col>
<!--                <i-col span="2">版权保险</i-col>-->
                <i-col span="3">证书</i-col>
                <i-col span="1">状态</i-col>
                <i-col span="7">操作</i-col>
            </Row>

            <errorTips :state="0" v-if="loadFlag && records.length == 0"></errorTips>

            <div v-else>
                <Row v-for="(item, index) in records"
                     :style="{background: item.index %2 == 0 ? 'rgba(228,228,228,1)' : '#fff' }"
                     class="table-style-size table-style-body">
                    <!-- 普通数据 -->
                    <template v-if="item.bizType == '02'">
                        <i-col span="1">
                            <!-- <img :src="currentIndex==index?yes:no" style=" width: 16px;height: 16px;" @click="selectItem(index,item)" /> -->
                            <img :src="dis" style=" width: 16px;height: 16px;cursor: no-drop;" v-if="item.insurance.insuranceStatus ==1" alt='版权登记'/>
                            <img :src="currentIndex==index?yes:no" style=" width: 16px;height: 16px;cursor:pointer;" v-else @click="selectItem(index,item)" alt='版权登记'/>
                        </i-col>
                        <i-col span="2">{{ item.subBizTypeCn }}</i-col>
                        <i-col span="2">
                            <Tooltip v-if="item.certCode && item.certCode != '' && !item.otherService"
                                     :content="item.certCode" placement="top">
                                <span class="notwrap"
                                      style="padding:0 5px;display: inline-block;width: 90px;vertical-align: bottom">{{ item.certCode }}</span>
                            </Tooltip>
                            <span v-else>-</span>
                        </i-col>
                        <i-col span="2">
                            <Tooltip :content="item.workFullname" placement="top">
                                <span class="notwrap"
                                      style="padding:0 5px;display: inline-block;width:90px;vertical-align: bottom">{{ item.workFullname }}<img src='../../insurance/images/baoxianlog.png' style="width:16px;height:16px;" v-if="item.insurance.insuranceStatus == 1"/></span>
                            </Tooltip>
                        </i-col>
                        <i-col span="3">{{ item.otherService ? item.recordCreateDate : item.createDate }}</i-col>
<!--                        <i-col span="2">
                            <a v-if="item.insurance.insuranceStatus == 0" style="color:#F7B500" @click="shangbaoxian(item)">上保险</a>
                            <a v-if="item.insurance.insuranceStatus == 1 && (item.insurance.policyUrl ==null || item.insurance.policyUrl =='')" style="color:#F7B500" @click="lookInsuranceInvoice(item)">查看保单</a>
                            <a v-if="item.insurance.insuranceStatus == 1 && item.insurance.policyUrl !=null && item.insurance.policyUrl !=''" style="color:#F7B500" @click="lookInsurance(item.insurance.policyUrl)">查看保单</a>
                        </i-col>-->
                        <i-col span="3">
						<span style="display: inline-block" v-if="item.subBizType == '0202'">
							<Tooltip v-if="item.cerImgPrivateUrl && item.cerImgPrivateUrl != ''" content="登记证书"
                                     placement="top">
								<a target="_blank" :href="item.certUrl">
								<img src="@/assets/dic_new.png" alt="登记证书"/>
							</a>
                            </Tooltip>
                            <Tooltip v-else content="暂无登记证书" placement="top">
								<img src="@/assets/dci_close_new.png" alt="登记证书"/>
							</Tooltip>
						</span>
                            <span style="display: inline-block" v-else-if="item.subBizType == '0201'">
							<Tooltip v-if="item.cerImgPrivateUrl && item.cerImgPrivateUrl != ''" content="登记证书"
                                     placement="top">
								<router-link :to="'/copyrightCert?url=' + item.cerImgPrivateUrl" target="_blank"
                                             tag="a">
								    <img src="@/assets/dci.png" alt='版权登记'/>
							    </router-link>
                            </Tooltip>
							<Tooltip v-else content="暂无登记证书" placement="top">
								<img src="@/assets/dci_close.png" alt='版权登记'/>
							</Tooltip>
						</span>
                            <span v-else>-</span>
                        </i-col>
                        <i-col span="1">{{ item.orderStatusCn }}</i-col>
                        <i-col span="7">
                            <div v-if="!item.otherService">
                                <router-link :to="'/copyrightDetails?id=' + item.orderSeqNo" class="btn-84"
                                             style="display: inline-block;margin:0 15px">详情
                                </router-link>

                                <router-link
                                        v-if="item.orderStatus == 'reject_editable' && item.subBizType == '0202'"
                                        :to=" item.rights && item.rights!= null ? '/copyrightRegistrationActivity?id=' + item.orderSeqNo + '&activityId=' + item.discountRightsOrderSeqNo : '/copyrightRegistration?id=' + item.orderSeqNo"
                                        class="btn-84"
                                        style="display: inline-block;margin:0 15px 0 0"
                                >
                                    编辑
                                </router-link>

                                <a v-if="item.certUrl && item.certUrl != ''" :href="item.certUrl" target="_blank"
                                   class="btn-84"
                                   style="display: inline-block;margin:0 15px 0 0">下载证书</a>
                                <div v-if="item.orderStatus == 'cert_sign_issue' && item.subBizType == '0202'"
                                     class="showphotow">
                                    <button class="btn-84">附加服务</button>
                                    <div class="showdiasy">
                                        <p v-for="(item2,index2) in moreItem" @click="shopModal(item,index2)">{{
                                            item2.name }}</p>
                                    </div>
                                </div>
                            </div>

                            <div v-else>-</div>

                        </i-col>
                    </template>

                    <!-- 活动数据 -->
                    <template v-else>
                        <i-col span="2">{{ item.workFullname }}</i-col>
                        <i-col span="3">
                            <span>-</span>
                        </i-col>
                        <i-col span="11">
                            <span>暂未使用权益，{{ item.rights != null && item.rights.enddate }} 前有效，超时不退费，请及时使用</span>
                        </i-col>
                        <i-col span="7">
                            <router-link v-if="item.rights && item.rights.overdueFlag == '0'" :to="'/copyrightRegistrationActivity?activityId=' + item.discountRightsOrderSeqNo"  class="btn-84"
                                         style="display: inline-block;margin:0 15px;width: auto;padding: 0 5px">请填写登记信息
                            </router-link>
                            <div v-else class="no_click_btn">请填写登记信息</div>
                        </i-col>

                    </template>


                </Row>
                <div class="commont-page"
                     style="position: absolute;bottom: 10px;left: 50%;transform: translate(-50%, -50%);">
                    <Page @on-change="changepage" :page-size="pageSize" :current="pageNumber" :total="total" size="small" show-total
                          show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{ pages }}页</span>
                </div>
            </div>
        </div>
        <!-- 申请纸质登记、证书查询、证书撤销、作品变更 -->
        <myDciorderup @fatherModal="fatherModal"
                      v-if="showModal"
                      :myDciorderupTitle="myDciorderupTitle"
                      :myDciorderupPay="myDciorderupPay"
                      :myDciorderupDownloadUrl="myDciorderupDownloadUrl"
                      :dataItem="dataItem"
                      :isActivity="isActivity"
                      ref="childModal"></myDciorderup>
    </div>
</template>

<script>
    import {_getByPage} from '@/api/register.js';
    import errorTips from '@/views/main-components/error-tips';
    import myDciorderup from './myDci-order-Up.vue';
    import Cookies from 'js-cookie';
    import {getInsuranceUrl,getShangInsurance} from '@/api/staticPage';
    export default {
        name: 'myDci',
        metaInfo: {
            title: '我的登记|版权服务专家|版权家',
            meta: [
                {
                    // set meta
                    name: 'keyWords',
                    content:
                        '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
                },
                {
                    name: 'Description',
                    content:
                        '权利人管理,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
                }
            ]
        },
        components: {
            errorTips,
            myDciorderup
        },
        data() {
            return {
                userInfo: Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : '',
                total: 0, //总数量
                pageNumber: 1, //当前页面
                pages: 1, //总页数
                pageSize: 8, //数据尺寸
                dateValue: [], //时间
                records: [], //登记数据
                workFullname: '', //登记名称
                loadFlag: false,//加载flag
                showModal: !1,
                dataItem: {},
                moreItem: [
                    {
                        name: '纸质版权登记',
                        engNumIndex:'paperCopyrightRegisterNum',
                        downloadUrl: 'https://file.bqj.cn/file/0490416198abb3835c162b79f47734ff.xlsx',
                        payCode: '0211'
                    },
                    {
                        name: '证书查询',
                        engNumIndex:'copyrightRegisterFindNum',
                        downloadUrl: 'http://pub-bluefile.bqj.cn/urkunde/9d18cda560977aa549eec53af6a8b9cf.docx',
                        payCode: '0212'
                    },
                    {
                        name: '证书撤销',
                        engNumIndex:'copyrightRegisterCancelNum',
                        downloadUrl: 'http://pub-bluefile.bqj.cn/urkunde/c4c45d981a9f6f1cf313b82687aa06a6.docx',
                        payCode: '0213'
                    },
                    {
                        name: '作品变更',
                        engNumIndex:'copyrightRegisterUpdateNum',
                        downloadUrl: 'http://pub-bluefile.bqj.cn/urkunde/0794d8ced9a57021e090312b80ba63c6.doc',
                        payCode: '0214'
                    },

                ], //登记相关操作下拉
                myDciorderupTitle: '',//申请类型
                myDciorderupDownloadUrl: '', //申请类型模板链接
                myDciorderupPay: '', //申请类型支付code
                serviceList: [
                    {name: '全部', subBizType: 'all'},
                    {name: '电子登记', subBizType: '0202,0201'},
                    {name: '纸质版权登记', subBizType: '0211'},
                    {name: '证书查询', subBizType: '0212'},
                    {name: '证书撤销', subBizType: '0213'},
                    {name: '作品变更', subBizType: '0214'},
                ], //服务类别
                serviceValue: 'all', //下拉框当前选中
                subBizType: '', //请求数据的类型
                isActivity: false, //是否活动
                insuranceId:"",
                currentIndex:null,
                yes: require('../../insurance/images/yes.png'),
                no:require("../../insurance//images/no.png"),
                dis:require("../../insurance//images/disCheck.png"),
            };
        },
        created() {
        },
        mounted() {
            this.getByPage();
        },
        methods: {
            //下载电子发票
            lookInsuranceInvoice(data){
                getShangInsurance(data.orderSeqNo).then(res=>{
                    if(res.code == 200){
                        window.open(res.result, '_blank')
                    }else{
                        toast(res.message)
                    }
                })
            },
            //查看保单
            lookInsurance(url){
                window.open(url, '_blank')
            },
            //上保险
            shangbaoxian(val){
                let data={
                    refSeqNo:val.orderSeqNo,
                    type:0
                }
                getInsuranceUrl(data).then(res=>{
                    if(res.code == 200){
                        window.open(res.result)
                        toast("成功上保险")
                        // this.applyBillFlagRegister = false;
                    }else{
                        // this.applyBillFlagRegister = false;
                        toast(res.message)
                    }
                })
            },
             //去了解上保险险情
            goInsurance(){
                this.$router.push({
                    path:'/insurance'
                })
            },
            //选择作品上保险
            //单选
            selectItem(index,data){
                this.currentIndex=index;
                console.log(data)
                this.insuranceId=data.orderSeqNo
            },
            insuranceCert(){
                let data={
                    refSeqNo:this.insuranceId,
                    type:0
                }
                if(this.insuranceId){
                    getInsuranceUrl(data).then(res=>{
                        if(res.code == 200){
                            window.open(res.result)
                            toast("成功上保险")
                             this.applyBillFlagRegister = false;
                        }else{
                             this.applyBillFlagRegister = false;
                            toast(res.message)
                        }
                    })
                }else{
                    toast("请选择要上保险的订单")
                }
            },
            /*********获取列表数据********/
            getByPage() {
                this.$refs['workFullnameInput'].blur();

                let data = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    sort: 'createDate',
                    order: 'desc',
                    startDate: this.dateValue[0] ? this.dateValue[0] : '',
                    endDate: this.dateValue[1] ? this.dateValue[1] : '',
                    workFullname: this.workFullname,
                    registerId: this.userInfo.id,
                    orderStatus: '',
                    subBizType: this.subBizType,
                };

                _getByPage(data).then(
                    res => {
                        if (res.code == 200) {
                            let result = res.result;
                            this.total = result.total - 0;
                            this.pages = result.pages;
                            this.records = result.records;
                            this.loadFlag = true;
                        } else {
                            toast(res.message);
                        }
                    },
                    err => {
                        toast('网络断开连接，请重试');
                    }
                );
            },

            /*********时间改变事件********/
            timeChange(value) {
                this.dateValue = value;
                this.searchReset();
            },

            /*********页数改变事件********/
            changepage(index) {
                this.pageNumber = index;
                this.getByPage();
            },

            /*********搜索重置事件********/
            searchReset() {
                this.pageNumber = 1;
                this.getByPage();
            },

            newOpen() {
              window.open('/copyrightRegistration', '_blank');
            },

            /*********搜索清空事件********/
            searchEmpty() {
                this.serviceValue = 'all';
                this.subBizType = '';
                this.dateValue = [];
                this.workFullname = '';
                this.pageNumber = 1;
                this.getByPage();
            },
            /*********弹框********/
            shopModal(item, index) {
                console.log(item);
                let _this = this;
                let moreItem = _this.moreItem;
                _this.myDciorderupTitle = moreItem[index].name;
                _this.myDciorderupDownloadUrl = moreItem[index].downloadUrl;
                _this.myDciorderupPay = moreItem[index].payCode; //申请类型支付code

                //用于判断是否有权益次数，控制附件服务的扣费是否显示
                if(item.rights && item.rights!=''){
                    if(item.rights[moreItem[index].engNumIndex] > 0){
                        this.isActivity = true;
                    }
                    else{
                        this.isActivity = false;
                    }
                }
                else{
                    this.isActivity = false;
                }

                _this.dataItem = item;
                _this.showModal = !0;
            },
            fatherModal(flag) {
                let _this = this;
                _this.showModal = !1;
                if (flag == 'success') {
                    this.searchEmpty();
                }
            },

            selectType(val) {
                console.log('这是获取的类型', val)
                this.subBizType = val == 'all' ? '' : val;
                this.pageNumber = 1;
                this.getByPage();
            },
        }
    };
</script>
<style scoped lang="less">
    .showphotow {
        display: inline-block;
        height: 100%;
        position: relative;
        /*margin-left: 20px;*/

        .showdiasy {
            position: absolute;
            top: 35px;
            left: 0;
            background: #fff;
            box-shadow: 0 2px 18px 0 rgba(179, 189, 199, .47);
            border-radius: 4px;
            z-index: 777;
            width: 110px;
            display: none;

            p {
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                font-size: 12px;
                background-color: #fff;
                color: #929292;
            }

            a {
                color: #929292;
            }

            a:hover {
                color: #4e4e4e;
            }

            p:hover {
                background-color: #f7f9fb;
                color: #4e4e4e;
            }
        }

        &:hover {
            .showdiasy {
                display: block;
            }
        }
    }

    .no_click_btn{
        margin: 0 15px;
        padding: 0 5px;
        height: 33px;
        display: inline-block;
        line-height: 33px;
        outline: none;
        background: #f6f6f6;
        border-radius: 2px;
        border: 1px solid #efefef;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        cursor: not-allowed;
    }
.caozuo-box{
    margin-bottom: 12px;
    background: #fff;
    display:flex;
    flex-direction:row;
    align-items:center;
    .xuqi_btn{
        margin-right: 10px;
        width: 84px;
        height: 33px;
        background: #ffd800;
        border: 1px solid #ffd800;
        border-radius: 2px;
        font-size: 12px;
        color: #333333;
        line-height: 33px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
        border: none;
        outline: none;
    }
}
</style>
